import styled from 'styled-components'
import { ScrollbarStyle } from '../../../../styles/components/scrollbar'
import { theme } from '../../../../styles/theme'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.colors.overlay.primary};
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const Modal = styled.div`
  max-height: 90vh;
  width: 100%;
  max-width: 500px;

  position: relative;

  overflow: hidden;


  background: ${theme.colors.mainBg};
  border-radius: ${theme.border.smallRadius};


  & > main {
    max-height: 80vh;
    overflow-x: hidden;
    overflow-y: auto;
    padding 25px;

    ${ScrollbarStyle}
  }

`

export const CloseButton = styled.button`
 position: absolute;
 top: 15px;
 right: 15px;
`

export const Header = styled.div`
  width: 100%;
  height: 70px;
  padding: 22px 24px;

  background-color: ${theme.colors.secondLightGray};

  display: flex;
  align-items: center;
  justify-content: space-between;

  & > h1 {
    font-size: ${theme.font.sizes.large};
    font-weight: ${theme.font.normal};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.brown};
  }

  & > button {
    background: none;
  }
`

export const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 80px 60px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > label {
    margin-bottom: 8px;

    font-family: ${theme.font.inter};
    font-weight: ${theme.font.semiBold};
    font-size: ${theme.font.sizes.large};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.brown};
  }

  & > input {
    width: 100%;
    height: 48px;
    padding: 13px;
    margin-bottom: 24px;

    border-radius: ${theme.border.smallRadius};
    border: 1px solid #B9C1CB;
    box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
    background: ${theme.colors.white};
    font-size: ${theme.font.sizes.small};
    font-family: ${theme.font.montserrat};
    color: ${theme.colors.brown};

    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #C4C4C4;
      opacity: 1; /* Firefox */
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #C4C4C4;
    }

    &::-ms-input-placeholder { /* Microsoft Edge */
      color: #C4C4C4;
    }
  }

  & > button {
    width: 100%;
    height: 48px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: ${theme.border.smallRadius};
    border: 1px solid #B9C1CB;
    box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
    background: ${theme.colors.green};
    font-size: ${theme.font.sizes.normal};
    font-family: ${theme.font.inter};
    color: ${theme.colors.mainBg};
  }
`

export const ConfirmAlert = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px 0px 40px;

  display: flex;
  flex-direction: column;
  align-items: center;
  

  & > img {
    width: 160px;
    height: 160px;
  }

  & > p {
    margin-bottom: 25px;
    
    text-align: center;
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.semiBold};
    font-size: ${theme.font.sizes.large};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.brown};
  }

  & > button {
    padding: 14.5px 29px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: ${theme.border.smallRadius};
    border: 1px solid #B9C1CB;
    box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
    background: #F2994A;
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.medium};
    font-family: ${theme.font.inter};
    color: ${theme.colors.mainBg};
  }
`
